<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="`language_question_${_uid}`"
    mode="eager"
    slim
    rules="required"
  >
    <v-select
      v-model="questionValue"
      outlined
      flat
      hide-details="auto"
      append-icon="mdi-account-voice"
      bottom
      clearable
      aria-label="Auswahl Sprachkenntnis"
      :placeholder="$t('pleaseSelect')"
      :items="options"
      :error-messages="errors"
      :menu-props="{ bottom: true, offsetY: true }"
      v-bind="$attrs"
    />
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      required: true
    },

    question: {
      type: Object,
      required: true
    }
  },

  computed: {
    options() {
      return [
        { text: this.$t('application.languageLevel.0'), value: 0 },
        { text: this.$t('application.languageLevel.1'), value: 1 },
        { text: this.$t('application.languageLevel.2'), value: 2 },
        { text: this.$t('application.languageLevel.3'), value: 3 },
        { text: this.$t('application.languageLevel.4'), value: 4 },
        { text: this.$t('application.languageLevel.5'), value: 5 },
        { text: this.$t('application.languageLevel.6'), value: 6 }
      ];
    },

    questionValue: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>
